import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart, NavigationCancel, NavigationError } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { MetaService } from './service/product-catalog/meta.service';
import { VersionCheckService } from './service/util/version-check.service';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { CanonicalLinkService } from './service/util/canonical-link.service';
import { EventsService } from 'angular4-events';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showGlobalLoader = true;
  private navigationStack = 0;

  constructor(public router: Router,
    private metaService: MetaService,
    private activatedRoute: ActivatedRoute,
    private versionCheckService: VersionCheckService,
    private titleService: Title,
    private canonicalLinkService: CanonicalLinkService,
    private events: EventsService) { }

  ngOnInit() {
    console.debug = function (name, data) {
      if (name && data) {
        console.log('%c' + name + ':' , 'color: white; background-color: #333333; padding: 2px 4px; border-radius: 2px', data);
      } else if (typeof name !== 'object' && !Array.isArray(name) ) {
        console.log('%c' + name, 'color: white; background-color: #D24919; padding: 2px 4px; border-radius: 2px');
      } else {
        console.log(name);
      }
    };

    if (environment.production) {
      // --- Habilitar lineas console para produccion - OCULTAR LOG
      console.info = function () { };
      console.log = function () { };
      console.debug = function () { };
      // console.error = function () { };
      console.warn = function () { };
    }

    this.loadEsimWidget();

    this.versionCheckService.initVersionCheck(environment.versionCheckURL);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.navigationStack++;
        this.showGlobalLoader = true;
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.navigationStack = Math.max(0, this.navigationStack - 1);
        if (this.navigationStack === 0) {
          this.showGlobalLoader = false;
          this.events.publish('hideAppLoader');
        }
      }
    });

    this.events.subscribe('hideAppLoader', () => {
      this.navigationStack = 0;
      this.showGlobalLoader = false;
    });

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event) => {
        this.canonicalLinkService.createOrUpdateCanonicalURL();
        this.metaService.updateMetadata(event['description'], event['keywords']);
        this.titleService.setTitle(event['title'] ? event['title'] : 'Compra - Virgin Mobile Colombia');
      });
  }

  private loadEsimWidget(): void {
    const url = (environment as any).esimWidgetUrl;
    if (!url) {
      return;
    }
    if (document.querySelector('script[data-esim-widget]')) {
      return;
    }
    const script = document.createElement('script');
    script.type = 'module';
    script.src = url;
    script.setAttribute('data-esim-widget', 'true');
    document.head.appendChild(script);
  }
}
